export interface FormState {
  koreId: string;
  bankRequestReference: string;
  bankName: string;
  settlementRail: string;
  accountIdentifier: string;
  operatorNotes: string;
  confirmed: boolean;
  sovereignOverride: boolean;
}

export interface FieldErrors {
  koreId?: string;
  bankRequestReference?: string;
  bankName?: string;
  settlementRail?: string;
  operatorNotes?: string;
  confirmed?: string;
}

export function validate(state: FormState): FieldErrors {
  const errors: FieldErrors = {};
  if (!state.koreId.trim()) errors.koreId = 'KoreID is required.';
  if (!state.bankName.trim()) errors.bankName = 'Bank Name is required.';
  if (!state.settlementRail.trim()) errors.settlementRail = 'A live settlement rail is required.';
  if (!state.operatorNotes.trim()) errors.operatorNotes = 'Operator Notes are required.';
  if (!state.confirmed) errors.confirmed = 'You must confirm this is an authorised bank request.';
  return errors;
}

export function isValid(state: FormState): boolean {
  return Object.keys(validate(state)).length === 0;
}

export const CONFIRM_PHRASE = 'CONFIRM SETTLEMENT';
